export default {
  legend: [
    {
      incidence: 0.2,
      mean: 0.43,
      quality: 0,
      title: 'Valeur dans la norme',
      subtitle: `La valeur n'est pas anormalement élevée en comparaison des
établissements participants de même type.`
    },
    {
      incidence: 2.5,
      mean: 0.5,
      quality: 2,
      title: 'Valeur «outlier»',
      subtitle: `<strong>Valeur > q3 + (q3 - q1) * 1.5</strong>
          ou <strong>Valeur < q1 - (q3 - q1) * 1.5</strong><br/>
La valeur est élevée ou basse par rapport à celles des établissements de même
type. Nous vous invitons à analyser les causes possibles de l'écart.
          `
    },
    {
      incidence: 0.5,
      mean: 0.5,
      quality: 1,
      title: 'Valeur seule',
      subtitle: `La valeur est seule dans sa catégorie et ne peut pas être
comparée avec d'autres.`
    },
    {
      incidence: 522,
      mean: 9.3,
      quality: 3,
      title: 'Valeur peu vraisemblante',
      subtitle: `<strong>Valeur trop élevée pour être vraisemblante </strong><br/> La valeur est
non vraisemblante et n'a pas été retenue dans les résultats nationaux. Par
exemple, un taux d'incidences de bactériémies pour 1000 journées
d'hospitalisation supérieur à 200 sera considéré non vraisemblant. Nous vous
invitons à vérifier les fiches saisies et les dénominateurs renseignés sur la
fiche établissement.`
    },
    {
      incidence: 0.5,
      mean: 0.033,
      quality: 4,
      title: 'Valeur non comparée',
      subtitle: `La valeur n'est pas comparée à la population de référence :
<ul>
  <li>soit parce que la population de référence n'est pas encore établie, <br>
    <i>La population de référence de l'année en cours est établie au 4e trimestre.</i>
  </li>
  <li>
    soit parce que la population de référence n'existe pas,<br>
    <i>
        Il n'existe pas de population de référence pour toutes les spécialités
        pour lesquelles les dénominateurs ne sont pas demandés, c'est à dire toutes sauf
        les spécialités d'AD&nbsp;REA, celles d'AD&nbsp;DIA, et la spécialité AD&nbsp;MED&nbsp;NEP.
    </i>
  </li>
  <li>
    soit parce que la valeur n'est pas inclue dans la population avec laquelle elle est comparée,<br>
    <i>
        Ce cas apparait si l'on compare le taux d'une Uf avec la discipline qui lui correspond,
        par exemple en comparant une Uf de réanimation polyvalente (AD&nbsp;REA&nbsp;POL) avec la population
        de la discipline AD&nbsp;REA.
    </i>
  </li>
  <li>
    soit parce qu'un filtre est actif.
  </li>
</ul>`
    },
    {
      incidence: 0.5,
      mean: 0.033,
      quality: 5,
      title: 'Valeur partielle',
      subtitle: `La valeur est partielle car l'utilisateur n'a pas les droits de visibilité sur
      l'ensemble des modalités où la spécialité a été surveillée. <br><br>Par
      exemple, si deux services de réanimation adulte polyvalente ont réalisé la
      surveillance : un service <i>S1</i> avec la modalité <i>Réa Inf ADI</i>
      et un service <i>S2</i> avec la modalité <i>Exp ADI</i>. <br><br>Un utilisateur
      n'ayant accès qu'aux résultats de la modalité <i>Exp ADI</i> verra bien
      les valeurs du service <i>S2</i> au niveau de l'Uf. En revanche les
résultats agrégés pour la discipline AD REA et la spécialité AD REA POL seront
incomplets, car il n'a pas accès aux résultats du service <i>S1</i>.`
    }
  ],

  incidences: [
    {
      key: 'hospit',
      title: `Taux d'incidence pour 1000 journées d'hospitalisation complètes`,
      text: `&sum; nombre d'infections associées à un dispositif invasif
&times; 1000 / nombre de journées d'hospitalisation complètes`,
      example: `taux d'incidence des bactériémies sur cvc pour 1000 journées
d'hospitalisation complètes.`
    },
    {
      key: 'adm',
      title: `Taux d'incidence pour 100 admissions`,
      text: `&sum; nombre d'infections associées à un dispositif invasif
&times; 100 / nombre de patients admis`,
      example: `taux d'incidence des bactériémies sur cathéter centraux pour 100 patients
admis.`
    },
    {
      key: 'pat',
      title: `Taux d'incidence pour 100 patients exposés`,
      text: `&sum; nombre d'infections associées à un dispositif invasif
&times; 100 / nombre de patients exposés au dispositif invasif concerné`,
      example: `taux d'incidence des pneumopathies pour 100 patients intubés.`
    },
    {
      key: 'cat',
      title: `Taux d'incidence pour 1000 journées dispositif
(cathéter, ventilation, etc.)`,
      text: `&sum; nombre d'infections associées à un dispositif invasif
&times; 1000 / nombre de journées d'exposition au dispositif invasif concerné`,
      example: `taux d'incidence des bactériémies sur cvo pour 1000 jours d'exposition au
cvo.`
    },
    {
      key: 'dia',
      title: `Taux d'incidence pour 1000 séances de dialyse`,
      text: `&sum; nombre d'infections associées à un site d'accès vasculaire
&times; 1000 / nombre de séances de dialyse dans lesquelles un patient est
porteur d'un site d'accès vasculaire : cathéter de dialyse, fistule native
ou fistule prothèse`,
      example: `taux d'incidence des bactériémies sur fistule prothèse pour 1000 séances de
dialyse.`
    }
  ]
}
